import { useForm } from '@mantine/form';

import { botTypes } from '../types';
import { validations } from '../validations';

type BotAllowedUserFormProps = {
  initialValues?: Omit<botTypes.AllowedUser, '_id'>;
};

export const useBotAllowedUserForm = ({ initialValues }: BotAllowedUserFormProps = {}) => {
  return useForm<Omit<botTypes.AllowedUser, '_id'>>({
    initialValues: {
      name: initialValues?.name || '',
    },

    clearInputErrorOnChange: true,

    validate: {
      name: (v) => (initialValues?.name ? validations.isRequired(v, 'Имя') : undefined),
    },
  });
};
